import { Navigate, RouteObject } from 'react-router-dom';

import { pagePathSegments } from '~constants';
import DeviceGroupDetailsPage from '~features/deviceGroups/pages/deviceGroupDetailsPage';

const devicegroupRoutes = (): RouteObject[] => {
	return [
		{
			path: pagePathSegments.DeviceGroups,
			children: [
				{
					// For now redirect to the devices page, since we don't have a page for
					// all device groups yet.
					index: true,
					element: <Navigate to={`../${pagePathSegments.Devices}`} replace />,
				},
				{ path: ':id', element: <DeviceGroupDetailsPage /> },
			],
		},
	];
};

export default devicegroupRoutes;
